"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resource = void 0;
var runnable_1 = require("./runnable");
var object_1 = require("./object");
var Resource = /** @class */ (function (_super) {
    __extends(Resource, _super);
    function Resource(name, parallelUsageLimit) {
        if (parallelUsageLimit === void 0) { parallelUsageLimit = 1; }
        var _this = _super.call(this, name) || this;
        _this.pool =
            parallelUsageLimit === 1
                ? new runnable_1.TaskQueue()
                : new runnable_1.TaskPool(parallelUsageLimit);
        _this.locked = false;
        return _this;
    }
    Resource.prototype.use = function (action) {
        var _this = this;
        if (this.locked) {
            throw new Error("Can't use " + this.toString() + " because it's locked.");
        }
        if (this.isDisposed()) {
            throw new Error("Can't use " + this.toString() + " because it's disposed.");
        }
        return this.pool.run(function () { return action(_this.resource); });
    };
    Resource.prototype.wait = function () {
        return this.pool.wait();
    };
    Resource.prototype.lock = function () {
        if (this.locked) {
            throw new Error(this.toString() + " already locked");
        }
        if (this.isDisposed()) {
            throw new Error("Can't use " + this.toString() + " because it's disposed.");
        }
        this.locked = true;
        return this.resource;
    };
    Resource.prototype.unlock = function () {
        this.locked = false;
    };
    Resource.prototype.isLocked = function () {
        return this.locked;
    };
    return Resource;
}(object_1.BaseObject));
exports.Resource = Resource;
